import React from "react";
// import { Container } from "react-bootstrap";
import Layout from "../../layout/Layout";
import img from '../../assets/images/About.png';
import img1mob from '../../assets/images/About-mob.png';
import img2 from '../../assets/images/Blog.png';
import img2mob from '../../assets/images/Blog-mob.png';
import img3 from '../../assets/images/Foundation.png';
import img3mob from '../../assets/images/Foundation-mob.png';
import img4 from '../../assets/images/BoxRecords.png';
import img4mob from '../../assets/images/BoxRecords-mob.png';
import { Link } from "react-router-dom";
import { ImCrying2 } from 'react-icons/im';

const AboutUs = (props: any) => {
  let userData                            = localStorage.getItem("profileData");
  return (
    <Layout>
      <div className="background-color">
       <div className="container-width mt-3 mb-3">
        <div className="row flex-lg-row-reverse">
          <div className="col-xl-6 text-center">
            {/* desktop only */}
            <img className="mb-2 d-none d-xl-block mx-auto aboutImgDesk" src={img} alt="about us" />
          </div>
          <div className="aboutUsMainCOntent col-xl-6">
             {/* ipad/mobile only */}
            <img className="img-fluid my-3 mx-auto rounded-circle  d-block d-xl-none" src={img1mob} alt="about us" />
              <h2 className="heading-title text-center text-xl-start"> About Us </h2>
              <div className=" text-white">
                <div className="mb-5">
                  {/* <h4><span className="theme-color">The Story Behind BeyondBox</span></h4> */}
                  <p className="mb-lg-4">BeyondBox was created from lived experience. Over the course of three years, beginning shortly after my young wife and I got married, we lost both sets of our parents. Grief arrived again and again, each time reshaping our world and forcing us to confront how fragile and unpredictable life truly is.</p>
                  <p>In the midst of that loss, we searched for ways to cope, to make sense of what had been taken, and to hold onto the voices, memories, and guidance of the people we loved. BeyondBox was born from that search. Initially as a way to preserve messages and legacy, but also as a quiet act of healing.</p>
                  <p>What began as a way to preserve messages and legacy grew into something
                  more. A space for reflection, gratitude, and intentional living. A reminder to
                  make the most of the moments we still have, while thoughtfully preparing what
                  we leave behind.</p>
                  <p>
                    A year later, we welcomed our son into the world. That moment changed
                    everything. New life brought perspective, gratitude, and a renewed awareness
                    of time. It made clear that legacy is not only something we leave behind, but
                    something we shape through how we live, love, and show up each day.
                  </p>
                  <p>As BeyondBox grew, so did our understanding of how closely life and legacy
                    are intertwined. Reflection, intention, memory, and preparation are not
                    separate acts. They are part of the same journey.</p>
                  <p>
                    Our sincere hope is that BeyondBox helps people find peace and purpose
                    during their lives, and provides profound support to the ones who will one day
                    have to say goodbye to them.
                  </p>
                  <p>Kapil & Advitha</p>
                </div>
                {!userData && <div className="text-center">
                  <Link to="/signup" className="button-secondary mt-3 mb-2 rounded-5"><span className='d-flex align-items-center'> Join BeyondBox </span></Link>
                </div>}
              </div>
          </div>
        </div>
      </div>
      </div>
    </Layout>
  );
};

export default AboutUs;